import { Component, Input } from '@angular/core';
import { DomainStatus, DomainStatusPresentation } from '../../../enums/domain-status.enum';

@Component({
  selector: 'app-domain-status',
  templateUrl: './domain-status.component.html',
  styleUrls: ['./domain-status.component.scss'],
  standalone: false
})
export class DomainStatusComponent {
  public readonly DomainStatus = DomainStatus;
  public readonly DomainStatusPresentation = DomainStatusPresentation;

  @Input()
  public status: DomainStatus;
}
